"use client";

import React from "react";
import { Spinner } from "@heroui/react";

/**
 * Loading state component for dashboard embedding.
 * Displays a centered spinner with semi-transparent overlay.
 */
export const DashboardLoading: React.FC = () => (
  <div className="absolute inset-0 flex items-center justify-center z-10">
    <Spinner size="lg" />
  </div>
);
